var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-attendance-bar",style:({
    top: `${_vm.startCoordinate}%`,
    height: `${_vm.barHeight}%`,
    display: `${_vm.barDisplay}`,
  })},[_c('div',{ref:"extend_top",staticClass:"extend_bar_top",on:{"mousedown":_vm.expandTop}}),_c('div',{ref:"extend_bottom",staticClass:"extend_bar_bottom",on:{"mousedown":_vm.expandBottom}})])
}
var staticRenderFns = []

export { render, staticRenderFns }